var _Rollbar = require("rollbar");

exports.onClientEntry = function (_, pluginOptions) {
  Rollbar = new _Rollbar(pluginOptions);
};
